import { httpV1 as http } from '@/services/api';

/**
 * Basic
 */

export async function getProducts() {
  return http.get('/products');
}

/**
 * Normal rates
 */

// get all rates
export async function getProductsRates(product_id, params, all = false) {
  return http.get(`/products/${product_id}/rates${all ? '/all' : ''}`, { params });
}

// get single rate
export async function getUniqueProductRate(product_id, id) {
  return http.get(`/products/${product_id}/rates/${id}`);
}

// create a rate
export async function createProductRate(product_id, data) {
  return http.post(`/products/${product_id}/rates`, data);
}

// update a rate
export async function updateProductRate(product_id, data) {
  return http.put(`/products/${product_id}/rates`, data);
}

/**
 * Promoter rates
 */

// get all
export async function getProductRatesPromoter({ product_id, promoter_id }) {
  return http.get(`/products/${product_id}/rates/promoter/${promoter_id}`);
}

// get single
export async function getProductRatePromoter({ product_id, params }) {
  return http.get(`/products/${product_id}/rates-promoter`, { params });
}

// create a promoter rate
export async function createProductRatePromoter({ product_id, data }) {
  return http.post(`/products/${product_id}/rates-promoter`, data);
}

// update a promoter rate
export async function updateProductRatePromoter({ product_id, rate_commission_id, data }) {
  return http.put(`/products/${product_id}/rates-promoter/${rate_commission_id}`, data);
}

// delete a promoter rate
export async function deleteProductRatePromoter({ product_id, rate_commission_id }) {
  return http.delete(`/products/${product_id}/rates-promoter/${rate_commission_id}`);
}

/**
 * Rate activation
 */

// create an activation register
export async function createActivationRate({ product_id, data }) {
  return http.post(`/products/${product_id}/rate-exception`, data);
}

// update an activation register
export async function updateActivationRate({ product_id, rate_promote_id, data }) {
  return http.put(`/products/${product_id}/rate-exception/${rate_promote_id}`, data);
}

// delete an activation register
export async function deleteActivationRate({ product_id, rate_promote_id }) {
  return http.delete(`/products/${product_id}/rate-exception/${rate_promote_id}`);
}

/** Bancarizadoras habilitadas para um produto. */
export async function getSuppliersList(params) {
  return http.get('/suppliers', { params });
}
